const t = "_icon_1sg67_1", s = "_rotate_1sg67_1", o = "_white_1sg67_5", n = "_brand_1sg67_9", _ = "_secondary_1sg67_13", c = {
  icon: t,
  rotate: s,
  white: o,
  brand: n,
  secondary: _
};
export {
  n as brand,
  c as default,
  t as icon,
  s as rotate,
  _ as secondary,
  o as white
};
//# sourceMappingURL=index.es741.js.map
